/**
 * Messaging & Communication Icons
 *
 * Icons for chat, messages, send, and communication features.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faComment as fadComment,
  faComments as fadComments,
  faCommentDots as fadCommentDots,
  faMessage as fadMessage,
  faMessages as fadMessages,
  faMessagePlus as fadMessagePlus,
  faMessageLines as fadMessageLines,
  faMicrophone as fadMicrophone,
  faMicrophoneSlash as fadMicrophoneSlash,
  faBell as fadBell,
  faInbox as fadInbox,
  faPaperPlaneTop as fadPaperPlaneTop,
  faCircleStop as fadCircleStop,
  faCirclePlay as fadCirclePlay,
  faFileLines as fadFileLines,
  faText as fadText,
  faFileWord as fadFileWord,
  faNoteSticky as fadNoteSticky,
  faPen as fadPen,
  faLink as fadLink,
  faCircleQuestion as fadCircleQuestion,
  faClipboardList as fadClipboardList,
  faFileCircleInfo as fadFileCircleInfo,
  faEnvelope as fadEnvelope,
  faGlobe as fadGlobe,
  faShuffle as fadShuffle,
  faListTimeline as fadListTimeline,
  faMessageCheck as fadMessageCheck,
  faMobile as fadMobile,
  faFileExcel as fadFileExcel,
  faPhoneVolume as fadPhoneVolume,
  faLifeRing as fadLifeRing,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faPaperPlane as fasPaperPlane,
  faMessage as fasMessage,
  faComments as fasComments,
  faDeleteLeft as fasDeleteLeft,
  faCalendarDay as fasCalendarDay,
  faCheckDouble as fasCheckDouble,
  faCircleCheck as fasCircleCheck,
  faPen as fasPen,
  faTriangleExclamation as fasTriangleExclamation,
  faLink as fasLink,
  faMicrophoneSlash as fasMicrophoneSlash,
} from '@fortawesome/pro-solid-svg-icons';

export const loadMessagingIcons = () => {
  library.add(
    fadComment,
    fadComments,
    fadCommentDots,
    fadMessage,
    fadMessages,
    fadMessagePlus,
    fadMessageLines,
    fadMicrophone,
    fadMicrophoneSlash,
    fadBell,
    fadInbox,
    fadPaperPlaneTop,
    fadCircleStop,
    fadCirclePlay,
    fasPaperPlane,
    fadFileLines,
    fadText,
    fasMessage,
    fasComments,
    fasDeleteLeft,
    fadFileWord,
    fadNoteSticky,
    fadPen,
    fasCalendarDay,
    fadLink,
    fadCircleQuestion,
    fadClipboardList,
    fadFileCircleInfo,
    fasCheckDouble,
    fadEnvelope,
    fadGlobe,
    fasCircleCheck,
    fasPen,
    fadShuffle,
    fasTriangleExclamation,
    fadListTimeline,
    fadMessageCheck,
    fasLink,
    fadMobile,
    fadFileExcel,
    fadPhoneVolume,
    fadLifeRing,
    fasMicrophoneSlash,
  );
};
